/*
 *   The name of the cookie in this file is being used in pages/checkout/complete/index.js,
 *   so if you change it here, you should also change it there.
 */
import { createCookie, deleteCookie } from "helpers/cookies/cookies.js";

const _config = {
  params: new URLSearchParams(window.location.search),
  cookieName: "fireAffiliateTransaction",
  cookiePeriod: 30, // nr of days the cookie should exist
  affiliates: [
    {
      name: "tradetracker",
      param: {
        name: "utm_medium",
        value: "affiliate",
      },
    },
  ],
  adwords: {
    param: "gclid",
    value: "",
  },
  excludes: [
    {
      name: "branding",
      param: {
        name: "swbranding",
        value: "",
      },
    },
  ],
};

export default () => {
  if (isAffiliateUrl()) {
    // this is an affiliate url or an adwords branding url, create the cookie
    createCookie(_config.cookieName, 1, _config.cookiePeriod);
  }
  if (isAdwordsUrl() && !isExcluded()) {
    // this is an adwords url, delete the cookie, also check if the affiliate check is false
    // because when it is adwords, but branding, the cookie should not be deleted.
    deleteCookie(_config.cookieName);
  }
};

const isExcluded = () => {
  let output = false;

  _config.params.forEach((value, key) => {
    _config.excludes.forEach((excludes) => {
      if (excludes.param.name === key) {
        // found the key as name of an affiliate
        if (excludes.param.value === "") {
          output = true;
        } else {
          if (excludes.param.value === _config.params.get(key)) {
            output = true;
          }
        }
      }
    });
  });

  return output;
};

export const isAffiliateUrl = () => {
  let output = false;

  _config.params.forEach((value, key) => {
    _config.affiliates.forEach((affiliate) => {
      if (affiliate.param.name === key) {
        // found the key as name of an affiliate
        if (affiliate.param.value === "") {
          output = true;
        } else {
          if (affiliate.param.value === _config.params.get(key)) {
            output = true;
          }
        }
      }
    });
  });

  return output;
};

export const isAdwordsUrl = () => {
  let output = false;

  _config.params.forEach((value, key) => {
    if (key === _config.adwords.param) {
      if (_config.adwords.value === "") {
        output = true;
      } else {
        if (_config.adwords.value === value) {
          output = true;
        }
      }
    }
  });

  return output;
};
